import React from "react";
import "../invoiceList/invoice.scss";

const InvoiceDetails = () => {
  return (
    <section id="invoiceDetails">
      <div className="container-fluid">
        <div className="row pt-1">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="card mb-1">
              <div className="card-body">
                <div className="row share-area-row">
                  <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 my-auto">
                    <div className="d-flex justify-content-between align-items-center">
                      <h6>
                        <i class="fas fa-angle-left mr-2"></i>DELR-DR-R664
                      </h6>
                      <button className="btn export-btn" type="button">
                        <i class="fas fa-share-square"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card mb-1">
              <div className="card-body">
                <div className="row invoice-details-row">
                  <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 my-auto"></div>
                  <table className="table table-borderless">
                    <tbody>
                      <tr>
                        <td>
                          <h5>ORD-789-JK95</h5>
                          <label>Delivery Date</label>
                        </td>
                        <td>
                          <h5>ORD-789-JK95</h5>
                          <label>Division</label>
                        </td>
                        <td>
                          <h5>ORD-789-JK95</h5>
                          <label>Customer Name</label>
                        </td>
                        <td>
                          <h5>ORD-789-JK95</h5>
                          <label>Project</label>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <h5>ORD-789-JK95</h5>
                          <label>Invoice Type</label>
                        </td>
                        <td>
                          <h5>ORD-789-JK95</h5>
                          <label>Customer LPO</label>
                        </td>
                        <td>
                          <h5>ORD-789-JK95</h5>
                          <label>Sales Engineer</label>
                        </td>
                        <td>
                          <h5>ORD-789-JK95</h5>
                          <label>Delivery Address</label>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <h5>ORD-789-JK95</h5>
                          <label>Payment Terms</label>
                        </td>
                        <td>
                          <h5>ORD-789-JK95</h5>
                          <label>Credit Days</label>
                        </td>
                        <td>
                          <h5>ORD-789-JK95</h5>
                          <label>Payment Due Date</label>
                        </td>
                        <td>
                          <h5>ORD-789-JK95</h5>
                          <label>Billing Address</label>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <h5>ORD-789-JK95</h5>
                          <label>Licensed Model</label>
                        </td>
                        <td>
                          <h5>ORD-789-JK95</h5>
                          <label>Delivery Note</label>
                        </td>
                        <td>
                          <h5>ORD-789-JK95</h5>
                          <label>Additional Note</label>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="card mb-1">
              <div className="card-body">
                <div className="row invoice-details-heading-row">
                  <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 my-auto">
                    <div>
                      <h6>Product Details</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card mb-1">
              <div className="card-body">
                <div className="row invoice-details-table-row">
                  <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 my-auto"></div>
                  <div className="table-responsive">
                    <table className="table table-borderless">
                      <thead>
                        <tr>
                          <th>Delivery Ref</th>
                          <th>Batch Ref</th>
                          <th>Product Group</th>
                          <th>Product Model</th>
                          <th>Tag Ref</th>
                          <th>Size Parameters</th>
                          <th className="text-right">Quantity</th>
                          <th className="text-right">Price</th>
                          <th className="text-right">Total</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>01-LAD/4956-59</td>
                          <td>SLSD-14-W2W3 Fifth Floor</td>
                          <td>1.5 hour Rated Static Fire Damper</td>
                          <td>KRLAD F-100</td>
                          <td>2400x3xOne Side</td>
                          <td>2400x3xOne Side</td>
                          <td className="text-right">200</td>
                          <td className="text-right">2400x3xOne Side</td>
                          <td className="text-right">2400x3xOne Side</td>
                          <td>
                            <span class="popover__wrapper">
                              <span class="material-symbols-rounded">info</span>
                              <div class="popover__content">
                                <div className="card">
                                  <div className="card-header">
                                    <h6>1.5 hour Rated Static Fire Damper</h6>
                                    <p>GModel - 119</p>
                                  </div>
                                  <div className="card-body">
                                    <table>
                                      <tbody>
                                        <tr>
                                          <td>
                                            <h5>ORD-789-JK95</h5>
                                            <label>Slot Width</label>
                                          </td>
                                          <td>
                                            <h5>ORD-789-JK95</h5>
                                            <label>Type</label>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <h5>ORD-789-JK95</h5>
                                            <label>
                                              Material of Construction
                                            </label>
                                          </td>
                                          <td>
                                            <h5>ORD-789-JK95</h5>
                                            <label>RAL Color</label>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <h5>ORD-789-JK95</h5>
                                            <label>Opposed Blade Damper</label>
                                          </td>
                                          <td>
                                            <h5>ORD-789-JK95</h5>
                                            <label>Bank Off Plate</label>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <h5>ORD-789-JK95</h5>
                                            <label>
                                              Blank Off Plate Material
                                            </label>
                                          </td>
                                          <td>
                                            <h5>ORD-789-JK95</h5>
                                            <label>Bank Off Plate Length</label>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <h5>ORD-789-JK95</h5>
                                            <label>Plenum</label>
                                          </td>
                                          <td>
                                            <h5>ORD-789-JK95</h5>
                                            <label>Plenum Width</label>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>01-LAD/4956-59</td>
                          <td>SLSD-14-W2W3 Fifth Floor</td>
                          <td>1.5 hour Rated Static Fire Damper</td>
                          <td>KRLAD F-100</td>
                          <td>2400x3xOne Side</td>
                          <td>2400x3xOne Side</td>
                          <td className="text-right">200</td>
                          <td className="text-right">2400x3xOne Side</td>
                          <td className="text-right">2400x3xOne Side</td>
                          <td>
                            <span class="popover__wrapper">
                              <span class="material-symbols-rounded">info</span>
                              <div class="popover__content">
                                <div className="card">
                                  <div className="card-header">
                                    <h6>1.5 hour Rated Static Fire Damper</h6>
                                    <p>GModel - 119</p>
                                  </div>
                                  <div className="card-body">
                                    <table>
                                      <tbody>
                                        <tr>
                                          <td>
                                            <h5>ORD-789-JK95</h5>
                                            <label>Slot Width</label>
                                          </td>
                                          <td>
                                            <h5>ORD-789-JK95</h5>
                                            <label>Type</label>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <h5>ORD-789-JK95</h5>
                                            <label>
                                              Material of Construction
                                            </label>
                                          </td>
                                          <td>
                                            <h5>ORD-789-JK95</h5>
                                            <label>RAL Color</label>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <h5>ORD-789-JK95</h5>
                                            <label>Opposed Blade Damper</label>
                                          </td>
                                          <td>
                                            <h5>ORD-789-JK95</h5>
                                            <label>Bank Off Plate</label>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <h5>ORD-789-JK95</h5>
                                            <label>
                                              Blank Off Plate Material
                                            </label>
                                          </td>
                                          <td>
                                            <h5>ORD-789-JK95</h5>
                                            <label>Bank Off Plate Length</label>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <h5>ORD-789-JK95</h5>
                                            <label>Plenum</label>
                                          </td>
                                          <td>
                                            <h5>ORD-789-JK95</h5>
                                            <label>Plenum Width</label>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </span>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td>Total Quantity: 2,800</td>
                          <td>Total Amount: 1,18,846.00</td>
                          <td>Other Charges: 0.00</td>
                          <td>
                            <span class="popover__wrapper">
                              <span class="material-symbols-rounded mr-1">
                                info
                              </span>
                              <div class="popover__content">
                                <div className="card">
                                  <div className="card-body">
                                    <table>
                                      <tbody>
                                        <tr>
                                          <td>
                                            <h5>350.00</h5>
                                            <label>Shipping Charges</label>
                                          </td>
                                          <td>
                                            <h5>300</h5>
                                            <label>Service Fees</label>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <h5>250.55</h5>
                                            <label>Handling Fees</label>
                                          </td>
                                          <td>
                                            <h5>99.45</h5>
                                            <label>Installation Fees</label>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </span>
                            Order Charge: 1,000.00
                          </td>
                          <td>Discount: 1,522.55</td>
                          <td>Net Total: 1,19,923.45</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InvoiceDetails;
